import axios from 'axios';
import { csrfFromDom } from 'common/utils/server';

export function requestConfig(config) {
  // Do something before request is sent
  const currentConfig = config;
  currentConfig.headers['Content-Type'] = 'application/json';
  currentConfig.headers['X-CSRF-token'] = csrfFromDom();
  return currentConfig;
}
export function requestConfigErr(error) {
  // Do something with request error
  return Promise.reject(error);
}
export function responseConfig(response) {
  // Do something with response data
  return response;
}
export function responseConfigErr(error) {
  // Do something with response error
  return Promise.reject(error);
}

const axiosInstance = axios.create();

// set headers
axiosInstance.interceptors.request.use(requestConfig, requestConfigErr);
axiosInstance.interceptors.response.use(responseConfig, responseConfigErr);

export default axiosInstance;
